import type { ReactElement } from 'react';
import { useRender } from '@base-ui/react/use-render';
import { EMPTY_VALUE } from '@/constants/app.constants';

const LINK_CLASS =
  'rounded text-left font-medium text-primary underline decoration-dotted underline-offset-2 hover:decoration-solid focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none';

interface DrillNameProps {
  value: string | null;
  label: string;
  render: ReactElement;
}

export function DrillName({ value, label, render }: DrillNameProps) {
  return useRender({
    defaultTagName: 'a',
    render,
    props: {
      'aria-label': label,
      className: LINK_CLASS,
      children: value === null || value === '' ? EMPTY_VALUE : value,
    },
  });
}
